import React from 'react'
import SavingImg1 from '../../Images/SavingImg/FestivalSaving.jpg'
import SideNav from '../Navigation/SideNav'
import Aos from 'aos'

const FestivalSaving = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>

            <div className='main'>
                <div className='left-fixed'></div>
                <div className='d-body'>
                    <div className='d-body-nav' data-aos='fade-right'>
                        <SideNav />
                    </div>
                    <div className='d-body-main' data-aos='fade-right'>
                        <div className='saving-body-top'>
                            <h2>चाडपर्व बचत</h2>
                        </div>
                        <div className='saving-body'>
                            <div className='saving-main'>
                                <h3>विशेषताहरू :</h3>
                                <p>
                                    <ul>
                                        <li>हरेक महिनाको मसान्तभित्र नियमित र ऐच्छिक रूपमा बचत गर्न सक्ने ।</li>
                                        <li>तोकिएको समयमा मात्र बचत फिर्ता पाईने । </li>
                                        <li>सम्झौताभन्दा अगावै बचत फिर्ता गर्नु पर्ने अवस्था आएमा ऐच्छिक बचत सरह ब्याज प्रदान गरी बचत फिर्ता गरिने ।</li>
                                        <li>तोकिएका पर्वमा गरिने कार्यक्रममा सहभागी गराईने ।</li>
                                        <li>खाता बन्द गर्दा रु.५० खाता बन्दी शुल्क लाग्ने । </li>
                                        <li>ब्याजलाई संरक्षित पूँजी फिर्ता कोष वितरणमा गणना गरिने । </li>
                                        <li>दशै, तिहार, तिज, जितिया, माघि पर्वको अवसरमा ९०% फिर्ता गर्न सकिने ।</li>
                                        <li>यस बचतको समयावधी कम्तिमा १ बर्षसम्मको हुने ।</li>
                                        <li>उत्कृष्ट बचत कर्तालाई पुरस्कार तथा सम्मान प्रदान गरिने ।</li>
                                    </ul>
                                </p>
                            </div>
                            <div className='savingimg'>
                                <img src={SavingImg1} alt='saving-1' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default FestivalSaving